import type { SVGProps } from 'react';

export function OtterIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.2 3.6c1.676 0 3.12.983 3.795 2.4h.105a.898.898 0 0 1 .3 1.747v.856q.001.077-.004.16c.45-.232.964-.36 1.504-.36h.3a1.2 1.2 0 1 1 0 2.4h-.3c-.498 0-.9.402-.9.901v.3h2.115a3.59 3.59 0 0 0-.915 2.4H12a3.6 3.6 0 0 1-2.501-1.011c-.71-.687-1.635-1.324-2.623-1.297-.339.009-.69.01-1.038.006-1.195-.014-2.222 1.092-1.272 1.815.4.304.897.486 1.434.486h2.4c.664 0 1.2.537 1.2 1.2 0 .664-.536 1.2-1.2 1.2h6v-2.4a2.395 2.395 0 0 1 2.4-2.4v-.6a1.8 1.8 0 0 1 1.8-1.8c.33 0 .6.271.6.601v1.6a.601.601 0 0 0 1.2 0v-1.739a4.2 4.2 0 0 0-2.873-3.986l-.318-.105a.6.6 0 0 1 .308-1.159l.746.15A7.13 7.13 0 0 1 24 11.959V12c0 4.639-3.762 8.4-8.4 8.4H9.577A8.377 8.377 0 0 1 1.2 12.023V10.53a3.38 3.38 0 0 1-.6-1.927v-.856A.898.898 0 0 1 .9 6h.105A4.2 4.2 0 0 1 4.8 3.6zM5.7 8.3c-.499 0-.9.401-.9.9v.139c0 .199.098.386.266.499l.447.296c.381.186.596.246.978 0l.443-.296a.61.61 0 0 0 .266-.5V9.2c0-.499-.401-.9-.9-.9zM3.6 7c-.33 0-.6.27-.6.6s.27.6.6.6.6-.27.6-.6-.27-.6-.6-.6m4.8 0c-.33 0-.6.27-.6.6s.27.6.6.6.6-.27.6-.6-.27-.6-.6-.6" />
    </svg>
  );
}
